import type { FileOpenErrorViewProps } from './components/FileOpenErrorView';
import type { MailboxInfo } from 'owa-client-types';
import type * as lazyIndex from './lazyIndex';
import { LazyAction, type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';
import type { OpenFileMessageResponse } from './utils/OpenFileMessageResponse';

const lazyModule = new LazyModule<typeof lazyIndex>(() => import('./lazyIndex'), {
    name: 'owa-mail-file-support/lazyFunctions',
});
export const lazyOpenFileMessage: LazyAction<
    typeof lazyIndex.openFileMessage,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.openFileMessage);
export const lazyConvertFileToMessageInService: LazyAction<
    (
        file: File,
        mailboxInfo?: MailboxInfo,
        skipMailboxCheck?: boolean,
        destinationFolderId?: string
    ) => Promise<OpenFileMessageResponse>,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.convertFileToMessageInService);
export const lazyOnDropFile: LazyAction<
    typeof lazyIndex.onDropFile,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.onDropFile);
export const lazyPopoutFileMessage: LazyAction<
    typeof lazyIndex.popoutFileMessage,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.popoutFileMessage);
export const FileOpenErrorView: LazyComponent<FileOpenErrorViewProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.FileOpenErrorView);
export const lazyCreateCopyItem: LazyAction<
    typeof lazyIndex.createCopyItem,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.createCopyItem);
export const lazyCreateCopyItemFailedNotification: LazyAction<
    typeof lazyIndex.createCopyItemFailedNotification,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.createCopyItemFailedNotification);
export const lazyIsTabFileActivation: LazyAction<
    typeof lazyIndex.isTabFileActivation,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.isTabFileActivation);
export const lazyIsTabFileActivationCached: LazyAction<
    typeof lazyIndex.isTabFileActivationCached,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.isTabFileActivationCached);
